import PARENT from '../types';

const RANDOMIZATION_HYPOTHESIS_TESTING = `${PARENT}/RANDOMIZATION_HYPOTHESIS_TESTING`;

export const RESET_RANDOMIZATION_HYPOTHESIS_TESTING = `${RANDOMIZATION_HYPOTHESIS_TESTING}/RESET`;

export default RANDOMIZATION_HYPOTHESIS_TESTING;
